import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import './EmailNotVerified.css';

const EmailNotVerified = () => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || 'nl');

  const toggleLanguage = () => {
    const newLanguage = language === 'nl' ? 'en' : 'nl';
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  return (
    <div className="email-not-verified-container">
      <Button
        variant="outlined"
        onClick={toggleLanguage}
        className="language-toggle-button"
        sx={{
          position: 'absolute',
          top: 20,
          right: 20,
          textTransform: 'none',
          fontWeight: 600
        }}
      >
        {language === 'nl' ? 'English' : 'Nederlands'}
      </Button>

      <h1>{t('emailNotVerifiedTitle')}</h1>
      <p>
        {t('emailNotVerifiedText1')}
      </p>
      <p>
        {t('emailNotVerifiedText2')}
      </p>
    </div>
  );
};

export default EmailNotVerified;
